import { StepperGenerationType } from '@/features/video-generation-stepper/types';

export enum TemplateFeatures {
  Avatar = 'avatar',
  BulkCreation = 'bulkCreation',
  ProductFocus = 'productFocus',
}

export enum TemplateTag {
  Fashion = 'Fashion',
}

export enum TemplateCategory {
  All = 'all',
  BrandAwareness = 'brandAwareness',
  ProductMarketing = 'productMarketing',
  SalesAndPromotion = 'salesAndPromotion',
}

export enum CategoryName {
  Website = 'website',
}

export enum TemplateName {
  MagicBackground = 'magicBackground',
  InfluencerAvatar = 'influencerAvatar',
  InfluencerVoiceOver = 'influencerVoiceOver',
  FounderAvatar = 'founderAvatar',
  BeautyShot = 'beautyShot',
  Promotional = 'promotional',
  ProductComparison = 'productComparison',
  ProductRelease = 'productRelease',
  BrandReview = 'brandReview',
  Lookbook = 'lookBook',
  SizingVideos = 'sizingVideos',
  ProductRotate = 'productRotate',
  Highlight = 'highlight',
}

export type Template = {
  id: TemplateName;
  title: string;
  description: string;
  image?: string;
  videoUrl?: string;
  specs?: string[];
  stepperGenerationType?: StepperGenerationType;
  category: TemplateCategory;
  features?: TemplateFeatures[];
  tags?: TemplateTag[];
  videoPosition?: string;
  videoDuration?: string;
};
